import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
    },
    {
        path: 'esqueci-senha',
        loadChildren: () => import('./primeiro-acesso-esqueci-senha/esqueci-senha.module').then(m => m.EsqueciSenhaModule)
    },
    {
        path: 'primeiro-acesso',
        loadChildren: () => import('./primeiro-acesso-esqueci-senha/esqueci-senha.module').then(m => m.EsqueciSenhaModule)
    },
    {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
        canActivate: [AuthGuard]
    }
];
